import { render } from "./FormularioVideoaula.vue?vue&type=template&id=2556022e&scoped=true"
import script from "./FormularioVideoaula.vue?vue&type=script&lang=js"
export * from "./FormularioVideoaula.vue?vue&type=script&lang=js"

import "./FormularioVideoaula.vue?vue&type=style&index=0&id=2556022e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2556022e"]])

export default __exports__